<template>
    <form
        ref="form"
        class="hts-form"
        @submit="onSubmit">
        <slot
            :errors="errors"
            :is-submitting="isSubmitting" />
    </form>
</template>
<script lang="ts" setup>
import { useForm } from 'vee-validate'

const emits = defineEmits(['submit'])
const props = defineProps({
  initialValues: {
    type: Object,
    default: () => {}
  },
  rules: {
    type: [Array, Object],
    default: () => {}
  }
})
const form = ref<any>()
const rules = toRef(props, 'rules')
let observer: any = null

const { handleSubmit, isSubmitting, submitForm, errors } = useForm({
  validationSchema: rules,
  initialValues: toRef(props, 'initialValues')
})
const onSubmit = handleSubmit((values: any, errors: any) => {
  emits('submit', values, errors)
})

const validate = () => {
  if (form.value) {
    form.value.querySelectorAll('[prop]').forEach((el: Element) => {
      const prop = el.getAttribute('prop')
      if (rules.value) {
        const rule = rules.value[prop as keyof typeof rules.value]
        if (rule) {
          if (typeof rule === 'object') {
            if (rule.required) {
              el.setAttribute('required', 'true')
            }
          } else if (typeof rule === 'string') {
            if (rule.includes('required')) {
              el.setAttribute('required', 'true')
            }
          }
        }
      }
    })
  }
}
if (process.client) {
  observer = new MutationObserver(validate)
}
onMounted(() => {
  if (observer) {
    observer.observe(form.value, {
      childList: true,
      subtree: true
    })
  }
  validate()
})
onBeforeUnmount(() => {
  if (observer) {
    observer.disconnect()
  }
})

defineExpose({ submitForm })
</script>
